import React, { useState } from 'react';
import contactImg from "../../assets/images/contact-img.svg";
import { CustomInput } from '../../shared/components/AllInputs';
import PrimaryButton from '../../shared/components/CustomButtons';
import Footer from '../../layout/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { resetContactState, submitContactForm } from '../../store/slices/contactSlice';
import { Toast } from 'primereact/toast';
import CustomInputTextArea from '../../shared/components/CustomInputTextArea';
import formValidation from "../../utils/validations";
import { showFormErrors } from '../../utils/commonFunctions';

export default function Contact() {
    const dispatch = useDispatch();
    const { loading, success, error } = useSelector((state) => state.contact);
    const toast = React.useRef(null);

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        subject: "",
        message: ""
    })

    const contactItems = [
        { id: 1, title: 'Phone', description: '+248-606-9694', iconClass: 'pi-phone' },
        { id: 2, title: 'Email', description: 'admin@redchilli.ai', iconClass: 'pi-envelope' },
        { id: 3, title: 'Website', description: 'https://redchilli.ai/', iconClass: 'pi-globe' }
    ];

    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, formData);
        setFormData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (showFormErrors(formData, setFormData)) {
            dispatch(submitContactForm(formData));
        }
    };

    React.useEffect(() => {
        if (success) {
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Your message has been sent successfully!',
                life: 3000
            });
            // Reset form
            setFormData({
                fullName: '',
                email: '',
                subject: '',
                message: ''
            });
            // Reset contact state after showing success message
            setTimeout(() => dispatch(resetContactState()), 3000);
        }

        if (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error || 'Failed to send message. Please try again.',
                life: 3000
            });
        }
    }, [success, error, dispatch]);
    return (
        <>

            <Toast ref={toast} />
            <div className='py-7'>
                <div className="container">
                    <div className="grid align-items-center">
                        <div className="md:col-6">
                            <img src={contactImg} alt="" className='w-full lg:w-auto' loading="lazy" />
                        </div>
                        <div className="md:col-6 contact-form">
                            <h1 className='mt-0'>Let's Start a Conversation</h1>
                            {/* <p className='content'>Enim tempor eget pharetra facilisis sed maecenas adipiscing. Eu leo molestie vel, ornare non id blandit netus.</p> */}
                            <form onSubmit={handleSubmit}>
                                <CustomInput
                                    label='Name'
                                    col={12}
                                    name="fullName"
                                    data={formData}
                                    onChange={handleChange}
                                    required
                                />
                                <CustomInput
                                    label='Email'
                                    col={12}
                                    name="email"
                                    data={formData}
                                    onChange={handleChange}
                                    required

                                />
                                <CustomInput
                                    label='Subject'
                                    col={12}
                                    name="subject"
                                    data={formData}
                                    onChange={handleChange}
                                    required
                                />
                                <CustomInputTextArea
                                    label='Message'
                                    name="message"
                                    data={formData}
                                    onChange={handleChange}
                                    required
                                    rows={5}
                                    col={12}
                                    placeholder="Write your message here."
                                />

                                < div className="col-12 mt-3">
                                    <PrimaryButton
                                        label={loading ? 'Sending...' : 'Send'}
                                        extraClassNames="mt-3"
                                        type="submit"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="grid justify-content-center mt-6">
                        {contactItems.map((item) => (
                            <div key={item.id} className="md:col-3">
                                <div className="icon-box text-center">
                                    <div className={`icon-img `}>
                                        <i className={` text-white pi ${item.iconClass}`} style={{ fontSize: "45px" }}></i>
                                    </div>
                                    <h4 className='my-2'>{item.title}</h4>
                                    <p className='my-2'>{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
